import React from 'react'
import Image, { type StaticImageData } from 'next/image'
import visitsBackground from '@/assets/images/refresh/category-hero/visits-bg.jpg'
import labsBackground from '@/assets/images/refresh/category-hero/labs-bg.jpg'
import medicationsBackground from '@/assets/images/refresh/category-hero/medications-bg.jpg'
import specialistsBackground from '@/assets/images/refresh/category-hero/specialists-bg.jpg'
import classes from './Background.module.css'

export type CategoryHeroBackgroundKey = 'visits' | 'labs' | 'medications' | 'specialists'

const BACKGROUND_IMAGES: Record<CategoryHeroBackgroundKey, StaticImageData> = {
    visits: visitsBackground,
    labs: labsBackground,
    medications: medicationsBackground,
    specialists: specialistsBackground,
}

/** Figma overlay alpha per background key (visits/medications confirmed; labs/specialists from frames). */
const OVERLAY_OPACITY: Record<CategoryHeroBackgroundKey, number> = {
    visits: 0.3,
    labs: 0.5,
    medications: 0.5,
    specialists: 0.4,
}

interface BackgroundProps {
    background: CategoryHeroBackgroundKey
}

export default function Background({ background }: BackgroundProps) {
    const src = BACKGROUND_IMAGES[background]
    if (src == null) return null

    return (
        <div
            className={classes.root}
            style={{ '--category-hero-overlay-opacity': OVERLAY_OPACITY[background] } as React.CSSProperties}
            aria-hidden
        >
            <Image
                src={src}
                alt=""
                fill
                sizes="(max-width: 48em) 100vw, 1360px"
                className={classes.image}
                priority
                decoding="async"
            />
            <div className={classes.overlay} />
        </div>
    )
}
